import { render, staticRenderFns } from "./KeyFour.vue?vue&type=template&id=675c363a&scoped=true&"
import script from "./KeyFour.vue?vue&type=script&lang=js&"
export * from "./KeyFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c363a",
  null
  
)

export default component.exports